import { render, staticRenderFns } from "./InformativeCardItem.vue?vue&type=template&id=58ee3bdb&scoped=true&"
import script from "./InformativeCardItem.vue?vue&type=script&lang=js&"
export * from "./InformativeCardItem.vue?vue&type=script&lang=js&"
import style0 from "./InformativeCardItem.vue?vue&type=style&index=0&id=58ee3bdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ee3bdb",
  null
  
)

export default component.exports